
//------------------------------------------------------------------------------
// <auto-generated>
//     This code was generated from a template (Model.tst).
//
//     Manual changes to this file may cause unexpected behavior in your application.
//     Manual changes to this file will be overwritten if the code is regenerated.
// </auto-generated>
//------------------------------------------------------------------------------

import { Model, ModelProperty } from 'models/Model';


export class InstallmentPaymentModel extends Model<InstallmentPaymentModel> {
	public static classProperties: ModelProperty[] = [
		
		{ name: 'id', type: 'string', isHidden: true },
		{ name: 'documentNo', type: 'string' },
		{ name: 'amount', type: 'number' },
		{ name: 'dueDate', type: 'Date' },
		{ name: 'paid', type: 'boolean' },
		{ name: 'brandId', type: 'string' }
	];
	[key: string]: any;
	
	public id?: string;
	public documentNo: string;
	public amount: number;
	public dueDate?: Date;
	public paid: boolean;
	public brandId?: string;
    
	constructor(){
		super();
		this.id = undefined;
		this.documentNo = '';
		this.amount = 0;
		this.dueDate = undefined;
		this.paid = false;
		this.brandId = undefined;
		
	}
	getProperties(){
		return InstallmentPaymentModel.classProperties;
	}
}

